import { UPDATE_SUBSIDIARY_ID_FOR_SINGLE_INVOICE } from '../actions/actionTypes'

const initialState = {
  invoiceList: null,
  billingAddress: null,
  invoiceAddress: null,
  subsidiarySubscriptions: [],
  billableBookings: [],
  billableSubsidiaryName: null,
  endDate: null,
  billableTotal: null,
  billableTax: null,
  billingTaxRate: null,
  conversionsWithoutCommission: [],
  conversions: [],
  invoiceDetails: null,
  isLoading: true,
  error: null,
  invoiceSubsidiary: null,
  selectedBookings: [],
  isGroupView: false,
  subsidiaryIdForSingleInvoice: null
}

export default function reviews(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case UPDATE_SUBSIDIARY_ID_FOR_SINGLE_INVOICE: {
      return {
        ...state,
        subsidiaryIdForSingleInvoice: action.payload
      }
    }

    case 'GET_INVOICES_STARTED':
      return {
        ...state,
        error: null,
        isLoading: true
      }

    case 'GET_INVOICES_FAILED':
      return {
        ...state,
        error: action.payload.message,
        isLoading: true
      }

    case 'GET_STATEMENT_STARTED':
      return {
        ...state,
        isLoading: true,
        error: null
      }

    case 'GET_STATEMENT_FAILED':
      return {
        ...state,
        error: action.payload.message,
        isLoading: false
      }

    case 'GET_STATEMENT_SUCCESS': {
      const invoiceData = action.payload

      return {
        ...state,
        isLoading: false,
        error: null,
        invoiceList: {
          ...state.invoiceList,
          ...invoiceData
        }
      }
    }

    case 'GET_BILLABLE_BOOKINGS_FAILED':
      return {
        ...initialState,
        billableBookingsFailed: true,
        billableBookingsLoading: false,
        billableBookingsError: action.payload
      }

    case 'GET_BILLABLE_BOOKINGS_STARTED':
      return {
        ...state,
        billableBookingsLoading: true,
        billableBookingsFailed: false,
        billableBookingsError: '',
        selectedBookings: []
      }

    case 'DESELECT_ALL_BILLABLE_BOOKINGS':
      return {
        ...state,
        billableBookings: state.billableBookings.map(b => ({
          ...b,
          isSelected: false
        })),
        selectedBookings: []
      }

    case 'SELECT_BILLABLE_BOOKINGS': {
      const billableBookings = state.billableBookings.map(b => {
        if (
          action.payload.bookingIds.some(id => id === b.convertedSubscriberHotelBookingId)
        ) {
          return { ...b, isSelected: b.isSelected ? false : true }
        } else {
          return b
        }
      })

      const selectedBookings = billableBookings.filter(b => b.isSelected)

      return {
        ...state,
        billableBookings,
        selectedBookings
      }
    }

    case 'GOT_BILLABLE_BOOKINGS': {
      const { billableBookings } = action.payload

      return {
        ...state,
        billableBookingsLoading: false,
        billableBookingsFailed: false,
        selectedBookings: [],
        billableBookingsError: '',
        billableBookings: billableBookings.conversionsForInvoiceReview.map(b => ({
          ...b,
          key: b.inviteBookingConversionDetailId,
          searchKey: (
            b.invitedSubscriberName +
            b.invitedPhoneNumber +
            b.invitedEmail +
            b.convertedClientName +
            b.convertedPhoneNumber +
            b.convertedEmail +
            b.invitedFormattedAddress +
            b.convertedFormattedAddress +
            b.convertedTrackingCode +
            b.convertedBookingStatus +
            b.convertedSubscriberHotelBookingId
          ).toLowerCase()
        })),
        endDate: billableBookings.invoiceDetails.endDate,
        billableSubsidiaryName: billableBookings.subsidiary.hotelName,
        billableSubsidiaryServices: billableBookings.subsidiary.subsidiarySubscriptions,
        billableInvoiceStatus: billableBookings.invoiceDetails.status,
        billableInvoiceDetails: billableBookings.invoiceDetails,
        totalAmountDue: billableBookings.invoiceDetails.totalAmountDue,
        totalTax: billableBookings.invoiceDetails.totalTax,
        totalFixedServices: billableBookings.invoiceDetails.totalFixedServices,
        updatedOn: billableBookings,
        billingTaxRate: billableBookings.subsidiary.billingTaxRate
      }
    }

    case 'UPDATE_BILLABLE_BOOKING':
      return {
        ...state,
        billableBookings: state.billableBookings.map(booking =>
          booking.convertedSubscriberHotelBookingId ===
          action.payload.booking.convertedSubscriberHotelBookingId
            ? {
                ...booking,
                isInvoicingRejected: action.payload.booking.isInvoicingRejected,
                invoiceRejectReason: action.payload.booking.invoiceRejectReason,
                lastReconciliationStatus: action.payload.booking.lastReconciliationStatus,
                hasTempFilterImmunity: true
              }
            : { ...booking, hasTempFilterImmunity: false }
        ),
        billableTotal: action.payload.invoice.total,
        billableTax: action.payload.invoice.tax,
        totalAmountDue: action.payload.invoice.totalAmountDue,
        totalTax: action.payload.invoice.totalTax,
        totalFixedServices: action.payload.invoice.totalFixedServices
      }

    case 'SAVE_POSTED_SUBSIDIARY':
      return {
        ...state
      }

    default:
      return state
  }
}
